/* ============================================================================
   Steffie's PDP size helper (2026-10-08). See snippets/steffie-size-helper.liquid.
   Sizing comes from the Fit Finder engine (assets/steffie-fit.js), loaded on demand,
   so the helper and the Fit Finder can never disagree. This file owns only the
   two-question flow, the copy, and how the answer lands on the size buttons.
   Talks to the PDP through window.SteffiePDP (sections/steffie-product.liquid).
   2026-10-11: when her full Fit Finder profile is newer than her two-tap answers, the
   "your size" line and the sheet use the Fit Finder result instead (it also knows her
   foot volume and ankle). Two-tap answers saved before this change have no time, so
   any Fit Finder profile counts as newer.
   ========================================================================== */
(function(){
  "use strict";
  var sheet = document.getElementById('steffie-size-helper');
  var cfgEl = document.getElementById('steffie-size-helper-cfg');
  if (!sheet || !cfgEl) return;
  var CFG = {}; try { CFG = JSON.parse(cfgEl.textContent); } catch(e){ return; }
  var body = document.getElementById('steffie-sh-body');
  var KEY = 'steffie_size_helper';
  var SIZES = ['5','5.5','6','6.5','7','7.5','8','8.5','9','9.5','10','10.5','11','11.5','12'];
  // Width answers map to the Fit Finder's width codes. Our own short descriptions (complete sentences, no dashes).
  var WIDTHS = [
    { code:'AA', label:'True narrow',     desc:'Most shoes feel roomy on you, and straps or heels tend to slip.' },
    { code:'A',  label:'Slightly narrow', desc:'Shoes are usually fine but can feel a little loose.' },
    { code:'B',  label:'Standard',        desc:'The everyday width most shoes are built for.' },
    { code:'C',  label:'Slightly wide',   desc:'You like a little extra room across the ball of your foot.' },
    { code:'D',  label:'Wide',            desc:'You need noticeably more room across the ball and a deeper toe box.' },
    { code:'?',  label:'Not sure',        desc:'That is fine. We will treat your feet as standard.' }
  ];
  var ans = { usual:null, width:null, ts:0 };
  try { var saved = JSON.parse(localStorage.getItem(KEY) || 'null'); if (saved && saved.usual && saved.width) ans = saved; } catch(e){}

  /* ---- her full Fit Finder profile (written by assets/steffie-fit.js) ---- */
  function fitProfile(){
    try { var p = JSON.parse(localStorage.getItem('steffie_fit_profile') || 'null'); return (p && p.ref) ? p : null; } catch(e){ return null; }
  }
  // The newer of the two wins. Two-tap answers only win when she gave them after her Fit Finder.
  function fitWins(){ var p = fitProfile(); return !!p && !((ans.ts || 0) > (p.ts || 0)); }

  /* ---- engine loader (shared promise) ---- */
  var enginePromise = null;
  function engine(){
    if (window.SteffieFitEngine) return Promise.resolve(window.SteffieFitEngine);
    if (enginePromise) return enginePromise;
    enginePromise = new Promise(function(resolve, reject){
      var s = document.createElement('script'); s.src = CFG.engine; s.async = true;
      s.onload = function(){ window.SteffieFitEngine ? resolve(window.SteffieFitEngine) : reject(); };
      s.onerror = reject; document.head.appendChild(s);
    });
    return enginePromise;
  }

  /* ---- the recommendation, from the Fit Finder's own rules ---- */
  function fmt(n){ return String(n); }
  // hasVol and ankle come from the Fit Finder; two taps assume no extra volume and a "just right" ankle.
  function recommend(E, usual, width, hasVol, ankle){
    var R = parseFloat(usual), I = E._internals, fam = CFG.fam, out = { fam:fam };
    var res;
    hasVol = !!hasVol; ankle = ankle || 'regular';
    if (fam === 'journey') res = I.journeyFit(R, width, hasVol);
    else if (fam === 'explorer') res = I.explorerFit(R, width, hasVol);
    else if (fam === 'glide') res = I.glideFit(R, width, hasVol);
    else res = I.landmarkFit(R, width, hasVol, ankle);   // two taps: "just right" ankle = the Fit Finder's "either" case
    if (!res || !res.recommended){ out.notForYou = true; return out; }
    var a = res.attempts[0];
    if (a.wide && !hasWideNow()){ a = res.attempts[1] || a; }     // this colorway has no Wide: the Fit Finder's regular-width size
    out.size = a.size; out.wide = !!a.wide && hasWideNow();
    if (out.wide && a.altSize) out.alt = a.altSize;
    out.label = fmt(out.size) + (out.wide ? ' Wide' : '');
    out.up = out.size - R;
    return out;
  }
  // The Fit Finder's size for the colorway on screen: the exact size it saved for this handle when there is one
  // (the same size ?fit_size= and the saved-size preselect use), otherwise its rules run on her full answers.
  function fitRecommend(E){
    var p = fitProfile(); if (!p) return null;
    var map = {}; try { map = JSON.parse(localStorage.getItem('steffie_fit_sizes') || '{}'); } catch(e){}
    var saved = map[handleNow()] || (p.handle === handleNow() ? p.size : null);
    if (saved){
      var label = String(saved).trim().replace(/\s*W(ide)?$/i, ' Wide');
      return { fam:CFG.fam, label:label, size:parseFloat(label), wide:/ Wide$/.test(label), src:'fit' };
    }
    var R = E.parseSize(p.ref); if (R == null) return null;
    var rec = recommend(E, R, p.width || '?', p.volume === 'full' || p.volume === 'swell', p.ankle);
    rec.src = 'fit';
    return rec;
  }
  // Whichever answers she gave most recently.
  function current(E){
    if (fitWins()){ var f = fitRecommend(E); if (f) return f; }
    if (ans.usual && ans.width){ var r = recommend(E, ans.usual, ans.width); r.src = 'helper'; return r; }
    return null;
  }
  function why(rec, width){
    var f = rec.fam, up = rec.up;
    if (f === 'landmark'){
      if (width === 'AA') return 'Your feet are truly narrow, so your usual size is right in Landmark.';
      if (rec.wide) return 'Landmark runs about a half size small. Our Wide gives you more room across the ball of your foot, which suits the width you described.';
      return up > 0.5 ? 'Landmark runs about a half size small, and the extra half size gives you room for the width you described.'
                      : 'Landmark runs about a half size small, so we have sized you up a half.';
    }
    if (f === 'journey') return up > 0 ? 'Journey fits true to size, and we have added a half size for room across the ball of your foot.'
                                       : 'Journey fits true to size, and its elastic back holds your heel snug.';
    if (f === 'explorer') return up > 0 ? 'Explorer runs a little short and is made to wear with socks, so we have sized you up.'
                                        : 'Your feet are truly narrow, so your usual size is right in Explorer.';
    if (f === 'glide'){
      if (up === 0) return 'Glide fits true to length, so your usual size is right.';
      return up < 0 ? 'Glide comes in whole sizes and its strap runs a little roomy, so we have taken you down a half size.'
                    : 'Glide comes in whole sizes, so we have taken you up a half size for the width you described.';
    }
    return '';
  }

  /* ---- PDP bridge ---- */
  function pdp(){ return window.SteffiePDP || null; }
  function handleNow(){ var h = pdp() && pdp().handle && pdp().handle(); if (h) return h; var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? m[1] : ''; }
  // Read live from the page, because a colorway swap replaces the sizes and title in place.
  function hasWideNow(){ var w = false; document.querySelectorAll('#steffie-pdp-sizes .steffie-size').forEach(function(b){ if (/Wide/.test(b.textContent)) w = true; }); return w; }
  function titleNow(){ var t = document.querySelector('.steffie-pdp__title'); return ((t && t.textContent) || CFG.title || '').replace(/\s*(New\s*)?\(Pre-Order\)\s*$/i, '').trim(); }
  function buttonFor(label){
    var hit = null;
    document.querySelectorAll('#steffie-pdp-sizes .steffie-size').forEach(function(b){ if (!hit && b.textContent.trim() === label) hit = b; });
    return hit;
  }
  function markRec(label, src){
    document.querySelectorAll('#steffie-pdp-sizes .steffie-size').forEach(function(b){ b.classList.toggle('is-rec', !!label && b.textContent.trim() === label); });
    var line = document.getElementById('steffie-pdp-rec');
    if (!line) return;
    if (!label){ line.hidden = true; line.textContent = ''; return; }
    var b = buttonFor(label);
    line.innerHTML = (src === 'fit' ? 'From your Fit Finder results' : 'From your answers') + ', <strong>size ' + label + '</strong> is your size in ' + esc(titleNow()) + '.' + (b && b.classList.contains('soldout') ? ' It is sold out right now.' : '');
    line.hidden = false;
  }
  // Two-tap orders only. A Fit Finder recommendation is already recorded as _fit_finder (steffie-footer.liquid).
  function stampForm(rec){
    var f = document.getElementById('steffie-pdp-form'); if (!f) return;
    var i = f.querySelector('input[name="properties[_size_helper]"]');
    if (!rec || !rec.label || rec.src !== 'helper'){ if (i) i.remove(); return; }
    if (!i){ i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[_size_helper]'; f.appendChild(i); }
    i.value = 'usual ' + ans.usual + ', width ' + ans.width + ', recommended ' + rec.label;
  }

  /* ---- sheet rendering ---- */
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }
  function stepSize(){
    body.innerHTML = '<p class="steffie-sheet__step">1 of 2</p>'
      + '<h2 class="steffie-sheet__h" id="steffie-sh-title">What size do you usually wear?</h2>'
      + '<p class="steffie-sheet__sub">Think of a pair that fits you well today.</p>'
      + '<div class="steffie-sheet__grid">' + SIZES.map(function(s){
          return '<button type="button" class="steffie-sheet__opt' + (ans.usual === s ? ' is-on' : '') + '" data-usual="' + s + '">' + s + '</button>';
        }).join('') + '</div>';
    focusFirst();
  }
  function stepWidth(){
    body.innerHTML = '<p class="steffie-sheet__step">2 of 2</p>'
      + '<h2 class="steffie-sheet__h" id="steffie-sh-title">How would you describe the width of your feet?</h2>'
      + '<div class="steffie-sheet__list">' + WIDTHS.map(function(w){
          return '<button type="button" class="steffie-sheet__row' + (ans.width === w.code ? ' is-on' : '') + '" data-width="' + w.code + '"><strong>' + w.label + '</strong><span>' + w.desc + '</span></button>';
        }).join('') + '</div>'
      + '<button type="button" class="steffie-sheet__back" data-sh-back>Back</button>';
    focusFirst();
  }
  function stepResult(){
    body.innerHTML = '<p class="steffie-sheet__sub">Finding your size…</p>';
    engine().then(function(E){
      var rec = current(E);
      if (!rec){ stepSize(); return; }
      var html = '';
      if (rec.notForYou){
        html = '<h2 class="steffie-sheet__h" id="steffie-sh-title">Glide is not the best fit for a truly narrow foot.</h2>'
          + '<p class="steffie-sheet__sub">Its strap runs roomy, so we would point you to Journey, which fits true to size for narrow feet.</p>'
          + '<a class="steffie-sheet__cta" href="/products/journey-sand">See Journey</a>';
        markRec(null);
      } else {
        var b = buttonFor(rec.label);
        html = rec.src === 'fit'
          ? '<h2 class="steffie-sheet__h" id="steffie-sh-title">Your Fit Finder results say size ' + esc(rec.label) + ' in ' + esc(titleNow()) + '.</h2>'
            + '<p class="steffie-sheet__sub">That comes from all of your Fit Finder answers, including your foot volume and ankle, so it is more precise than two quick questions.</p>'
          : '<h2 class="steffie-sheet__h" id="steffie-sh-title">We recommend size ' + esc(rec.label) + ' in ' + esc(titleNow()) + '.</h2>'
            + '<p class="steffie-sheet__sub">' + esc(why(rec, ans.width)) + '</p>';
        if (rec.alt) html += '<p class="steffie-sheet__sub">If you would rather have the regular width, choose size ' + esc(fmt(rec.alt)) + '.</p>';
        if (!b){
          html += '<p class="steffie-sheet__sub">We do not make size ' + esc(rec.label) + ' in this style yet. Email <a href="mailto:help@steffies.com">help@steffies.com</a> and a real person will help you find the closest fit.</p>';
        } else if (b.classList.contains('soldout')){
          var alts = (pdp() && pdp().altsFor) ? pdp().altsFor(rec.label) : [];
          html += '<p class="steffie-sheet__sub">Size ' + esc(rec.label) + ' is sold out in this color right now.'
            + (alts.length ? ' It is in stock in ' + alts.map(function(a){ return '<a href="/products/' + esc(a.handle) + '?fit_size=' + encodeURIComponent(rec.label) + '">' + esc(a.color) + '</a>'; }).join(', ') + '.' : '') + '</p>'
            + '<button type="button" class="steffie-sheet__cta steffie-sheet__cta--ghost" data-sh-pick="' + esc(rec.label) + '">Choose It and Get an Email When It Is Back</button>';
        } else {
          html += '<button type="button" class="steffie-sheet__cta" data-sh-pick="' + esc(rec.label) + '">Choose Size ' + esc(rec.label) + '</button>';
        }
        markRec(b ? rec.label : null, rec.src);
        stampForm(rec);
      }
      html += '<button type="button" class="steffie-sheet__back" data-sh-restart>' + (rec.src === 'fit' ? 'Answer Two Quick Questions Instead' : 'Start Over') + '</button>';
      body.innerHTML = html;
      focusFirst();
    }).catch(function(){
      body.innerHTML = '<h2 class="steffie-sheet__h" id="steffie-sh-title">We could not load the size helper.</h2><p class="steffie-sheet__sub">The <a href="/pages/fit-finder">Fit Finder</a> will give you your size, or email help@steffies.com and a real person will help.</p>';
    });
  }
  // Move focus to the question itself (not the first option, which would look already chosen).
  function focusFirst(){ var h = body.querySelector('.steffie-sheet__h'); if (h){ h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll:true }); } catch(e){} } }

  var lastFocus = null;
  function open(){
    lastFocus = document.activeElement;
    sheet.hidden = false; sheet.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ sheet.classList.add('is-open'); });
    engine().catch(function(){});           // warm the engine while she answers
    if (fitWins() || (ans.usual && ans.width)) stepResult(); else stepSize();
  }
  function close(){
    sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    setTimeout(function(){ sheet.hidden = true; }, 250);
    if (lastFocus) try { lastFocus.focus({ preventScroll:true }); } catch(e){}
  }
  function save(){ try { localStorage.setItem(KEY, JSON.stringify(ans)); } catch(e){} }

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-size-helper-open]')){ e.preventDefault(); open(); return; }
    if (!sheet.contains(e.target)) return;
    var t;
    if (e.target.closest('[data-sh-close]')){ close(); return; }
    if ((t = e.target.closest('[data-usual]'))){ ans.usual = t.dataset.usual; stepWidth(); return; }
    if ((t = e.target.closest('[data-width]'))){ ans.width = t.dataset.width; ans.ts = Date.now(); save(); stepResult(); return; }
    if (e.target.closest('[data-sh-back]')){ stepSize(); return; }
    if (e.target.closest('[data-sh-restart]')){ ans = { usual:null, width:null, ts:0 }; save(); markRec(null); stepSize(); return; }
    if ((t = e.target.closest('[data-sh-pick]'))){ if (pdp()) pdp().pick(t.dataset.shPick); close(); return; }
    if (e.target.closest('[data-sh-chart]')){ e.preventDefault(); close(); var sg = document.querySelector('[data-sizeguide]'); if (sg) setTimeout(function(){ sg.click(); }, 260); return; }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !sheet.hidden) close(); });

  // Returning shopper: show "your size" on this style too (no selection is made for her).
  function refreshRec(){
    if (!fitProfile() && !(ans.usual && ans.width)) return;
    engine().then(function(E){ var rec = current(E); if (rec && !rec.notForYou){ markRec(buttonFor(rec.label) ? rec.label : null, rec.src); stampForm(rec); } }).catch(function(){});
  }
  refreshRec();
  document.addEventListener('steffie:sizes-rendered', refreshRec);   // colorway swapped in place
})();
